const BASE_URL = '/api/v1'

function getApiKey(): string | null {
  return localStorage.getItem('api_key')
}

async function request<T>(path: string, options: RequestInit = {}): Promise<T> {
  const apiKey = getApiKey()

  const response = await fetch(`${BASE_URL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(apiKey ? { Authorization: `Bearer ${apiKey}` } : {}),
      ...options.headers,
    },
  })

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Unknown error' }))
    if (response.status === 401) {
      window.dispatchEvent(new CustomEvent('auth:unauthorized'))
    }
    throw { status: response.status, ...error }
  }

  return response.json()
}

export const api = {
  async get<T>(path: string): Promise<T> {
    return request<T>(path)
  },

  async post<T>(path: string, body?: unknown): Promise<T> {
    return request<T>(path, { method: 'POST', body: JSON.stringify(body) })
  },

  async patch<T>(path: string, body?: unknown): Promise<T> {
    return request<T>(path, { method: 'PATCH', body: JSON.stringify(body) })
  },

  async delete<T>(path: string): Promise<T> {
    return request<T>(path, { method: 'DELETE' })
  },
}
